import TableCellTooltip from './TableCellTooltip'

export default TableCellTooltip
